import cn from 'classnames'
import { FC, useCallback } from 'react'

import { Translation } from 'cng-common/features/translations'
import { getKeyInitiativeStatusTranslationKey } from 'partner360/entities/keyInitiatives/model/status'

import { getStatusColorByValue } from '../../helpers/getStatusColorByValue'
import styles from '../../Status.module.scss'

interface IStatusView {
  value: string
  className?: string
  isReadonly?: boolean
  onClick?: (value: string) => void
}

export const StatusView: FC<IStatusView> = ({ value, className, isReadonly, onClick }) => {
  const handleClick = useCallback(() => {
    if (onClick) {
      onClick(value)
    }
  }, [onClick, value])

  return (
    <div
      onClick={handleClick}
      className={cn(styles.value, className, getStatusColorByValue(value), {
        [styles.isReadonly]: isReadonly,
      })}
    >
      <Translation text={getKeyInitiativeStatusTranslationKey(value)} span />
    </div>
  )
}
